"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useMedia_1 = require("./useMedia");

exports.default = useMedia_1.default;
exports.useMedia = useMedia_1.useMedia;
exports.useMediaLayout = useMedia_1.useMediaLayout;